import { Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { styled } from '@mui/system';

export const P2PImageContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  borderRadius: theme.spacing(1),
  border: `1px solid ${alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity)}`,
  background: alpha(
    theme.palette.primary.main,
    theme.palette.action.hoverOpacity,
  ),
  padding: theme.spacing(2),
  gap: 1,
  margin: theme.spacing(1, 1.5, 0),
}));
